<template>
  <div class="chat-messages p-4" v-if="messages?.length">

    <button
      class="btn text-right mb-2 btn-link shadow-none align-self-end"
      v-if="hasMore"
      @click="loadMore"
    >
      Load more...
    </button>

    <template v-for="(message, index) in sortedMessages">

      <!-- Date separator -->
      <div
        v-if="showDateSeparator(message, index)"
        :key="`date-${message.id}`"
        class="date-separator"
      >
        <span>{{ message.created_at_diff }}</span>
      </div>

      <div
        class="pb-4 d-flex align-items-center"
        :class="[message.sender_id === profile.id ? 'chat-message-right' : 'chat-message-left']"
        :key="`message-${message.id}`"
      >
        <div>
          <img
            :src="message.sender_id === profile.id ? (profile.profile_image ?? '/profile_images/default.png') : (coach.profile_image ?? '/profile_images/default.png')"
            class="rounded-circle mr-1"
            :alt="profile.first_name"
            width="40"
            height="40"
          />
        </div>
        <div class="flex-shrink-1 bg-light rounded py-2 px-3 mr-3">
          <div class="font-weight-bold mb-1">
            {{ message.sender_id === profile.id ? 'You' : `${coach.first_name} ${coach.last_name}` }}
          </div>
          {{ message.message }}
          <div class="message-time">{{ message.created_at_time }}</div>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
export default {
  props: {
    messages: Array,
    hasMore: Boolean,
    coach: Object
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    sortedMessages() {
      return this.messages
      // if (!this.messages) return [];
      // return this.messages.slice().sort((a, b) => {
      //   const da = this.parseUtc(a.created_at);
      //   const db = this.parseUtc(b.created_at);
      //   return (da || 0) - (db || 0);
      // });
    },
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
    showDateSeparator(message, index) {
      if (index === 0) {
        return true
      }

      const currDate = message.created_at?.split(' ')[0]
      const prev = this.sortedMessages[index - 1]?.created_at.split(' ')[0]

      return currDate !== prev
    },
  }
}
</script>

<style scoped>

.chat-messages {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.chat-message-left,
.chat-message-right {
  display: flex;
  flex-shrink: 0
}

.chat-message-left {
  margin-right: auto
}

.chat-message-right {
  flex-direction: row-reverse;
  margin-left: auto
}

.message-time {
  font-size: 0.68rem;
  color: #999;
  text-align: right;
  margin-top: 4px;
}

.date-separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 12px 0;
}

.date-separator::before,
.date-separator::after {
  content: '';
  flex: 1;
  border-top: 1px solid #dee2e6;
}

.date-separator span {
  padding: 2px 12px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #888;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 20px;
  white-space: nowrap;
  margin: 0 8px;
}
</style>
